'use client';

import { c as _c } from "react/compiler-runtime";
import { type ThemeMode, useThemeMode } from '@morpho-org/ui-v6/hooks';
import { useMemo } from 'react';
import { type ChartTheme, darkChartTheme, lightChartTheme } from '../helpers/chartTheme';
export interface UseChartThemeResult {
  theme: ChartTheme;
  themeMode: ThemeMode;
}

/**
 * Replacement for the V5 `useThemeContext()` inside the chart system.
 * Resolves the raw chart theme values for the active theme mode
 * (Highcharts options need raw color strings, not CSS variables).
 */
export function useChartTheme() {
  const $ = _c(3);
  const themeMode = useThemeMode();
  const t0 = themeMode === "light" ? lightChartTheme : darkChartTheme;
  let t1;
  if ($[0] !== t0 || $[1] !== themeMode) {
    t1 = {
      theme: t0,
      themeMode
    };
    $[0] = t0;
    $[1] = themeMode;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}